export default "__VITE_ASSET__ZD21bJ7$__"